export default __webpack_public_path__ + "static/media/breathe4.76fcffd9.gif";